(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("calendarSettingsService", ["$q", "_", calendarSettingsService]);
    function calendarSettingsService($q, _) {
        var calendarSettingsServiceFactory = {};
        var init = function () {
            return calendarSetup({});
        };
        var calendarSetup = function (settings) {
            settings.today = function () {
                settings.dt = new Date();
            };
            settings.today();
            settings.clear = function () {
                settings.dt = null;
            };
            settings.toggleMin = function () {
                settings.minDate = settings.minDate ? null : new Date();
            };
            settings.dateOptions = {
                formatYear: "yyyy",
                startingDay: 1
            };
            settings.dateOptions2 = {
                formatYear: "yyyy",
                startingDay: 1
            };
            settings.futureDates = {
                formatYear: "yyyy",
                startingDay: 1,
                minDate: new Date()
            };
            settings.toggleMin();
            return settings;
        };
        var open = function ($event, vm) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.opened = true;
            vm.openedTwo = false;
        };
        var openSecond = function ($event, vm) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.opened = false;
            vm.openedTwo = true;
        };
        var openToggle = function ($event, datePickerList, datepicker) {
            $event.preventDefault();
            $event.stopPropagation();
            var oldValue = datePickerList[datepicker];
            var keys = _.keys(datePickerList);
            _.each(keys, function (item) {
                datePickerList[item] = false;
            });
            datePickerList[datepicker] = !oldValue;
        };
        var checkDate = function (date) {
            return $q(function (resolve, reject) {
                if (date) {
                    if (!angular.isDate(date)) {
                        date = new Date(date);
                    }
                    //date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
                    if (date > new Date()) {
                        reject();
                        return;
                    }
                }
                resolve(true);
            });
        };
        var checkDateNotInThePast = function (date) {
            return $q(function (resolve, reject) {
                if (date) {
                    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
                    if (date > new Date())
                        resolve(true);
                    else
                        reject();
                }
                else
                    resolve(true);
            });
        };
        var checkFutureDate = function (date) {
            return $q(function (resolve, reject) {
                if (date) {
                    if (date > new Date())
                        resolve(true);
                    else
                        reject();
                }
                else
                    resolve(true);
            });
        };
        calendarSettingsServiceFactory.init = init;
        calendarSettingsServiceFactory.calendarSetup = calendarSetup;
        calendarSettingsServiceFactory.checkDate = checkDate;
        calendarSettingsServiceFactory.checkDateNotInThePast = checkDateNotInThePast;
        calendarSettingsServiceFactory.checkFutureDate = checkFutureDate;
        calendarSettingsServiceFactory.open = open;
        calendarSettingsServiceFactory.openSecond = openSecond;
        calendarSettingsServiceFactory.openToggle = openToggle;
        return calendarSettingsServiceFactory;
    }
}());
